import _get from 'lodash/get';
import { AttachmentValue } from '@lib/components/FileUploaderUppy/FileUploaderUppy';
import PdfPreviewPlaceholderBlock from '@lib/assets/images/pdf-preview-placeholder-block.svg';
import PdfPreviewPlaceholder from '@lib/assets/images/pdf-preview-placeholder.svg';
import CsvPreviewPlaceholder from '@lib/assets/images/csv-preview-placeholder.svg';
import XlsxPreviewPlaceholder from '@lib/assets/images/xlsx-preview-placeholder.svg';
import XlsPreviewPlaceholder from '@lib/assets/images/xls-preview-placeholder.svg';
import VideoPreviewPlaceholder from '@lib/assets/images/video-preview-placeholder.svg';
import ZipPreviewPlaceholder from '@lib/assets/images/zip-preview-placeholder.svg';
import { DocumentationPreviewEnum } from '../enums';

type Args = {
  attachment: AttachmentValue;
  mimeType: string;
  fileFormat: string;
  view: DocumentationPreviewEnum;
  useDefaultPdfPreview?: boolean;
};

const getPreviewImgUrl = ({
  attachment,
  mimeType,
  fileFormat,
  view,
  useDefaultPdfPreview,
}: Args): string => {
  const defaultPdfPreview =
    view === DocumentationPreviewEnum.BlockCard
      ? PdfPreviewPlaceholderBlock
      : PdfPreviewPlaceholder;

  if (useDefaultPdfPreview && fileFormat === 'pdf') {
    return defaultPdfPreview;
  }
  if (fileFormat === 'csv') return CsvPreviewPlaceholder;
  if (fileFormat === 'xlsx') return XlsxPreviewPlaceholder;
  if (fileFormat === 'xls') return XlsPreviewPlaceholder;
  if (mimeType.startsWith('video/')) return VideoPreviewPlaceholder;
  if (fileFormat === 'zip' || fileFormat === 'x-zip-compressed') {
    return ZipPreviewPlaceholder;
  }
  if (fileFormat === 'pdf') {
    return (
      _get(attachment, 'url') ||
      _get(attachment, ['urls', 'imagePreview']) ||
      defaultPdfPreview
    );
  }
  return (
    _get(attachment, 'url') ||
    _get(attachment, ['urls', 'imagePreview']) ||
    _get(attachment, ['urls', 'small']) ||
    _get(attachment, ['fileData', 'url'])
  );
};

export default getPreviewImgUrl;
